import { library } from '@fortawesome/fontawesome-svg-core';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { IconButton } from '@mui/joy';
import { useConfiguration } from 'common/hooks/useConfiguration';
import { useInjection } from 'inversify-react';
import { ReactElement } from 'react';
import { IUserStore, Plan } from '../../user/user.store';

library.add(faShoppingCart);

export const Limit = (): ReactElement => {
  const { t } = useTranslator();
  const userStore = useInjection(IUserStore.$);
  const config = useConfiguration();

  const {
    planInfo: { plan, dataRetentionDate },
  } = userStore;

  const date = dataRetentionDate ? new Intl.DateTimeFormat('en-us', { dateStyle: 'long' }).format(new Date(dataRetentionDate)) : '';

  return (
    <>
      {!config.appConfig.runLocally && userStore.userInfo.showCart && (
        <div className='top-nav-item'>
          <IconButton
            title={t(plan === Plan.Free ? 'cart_free' : 'cart_inactive', { dataRetentionDate: date })}
            size='lg'
            variant='topbar'
            href='mailto:acdl-support@zebra.com'
            component='a'
          >
            <FontAwesomeIcon
              icon={faShoppingCart}
              fixedWidth
            />
          </IconButton>
        </div>
      )}
    </>
  );
};
